import type { Collection } from "@/types";

export const collections: Collection[] = [
  {
    id: "c-01",
    title: "年度科幻精选",
    subtitle: "驶向星辰的想象力",
    desc: "从深海到星河，六部作品带你穿越人类想象力的边界，感受科幻外壳下最动人的人性温度。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20sci-fi%20collection%20cover%20with%20glowing%20crimson%20nebula%20and%20a%20small%20spaceship%2C%20warm%20orange%20space%20tones%2C%20clean%20editorial%20composition&width=800&height=600&seq=tc-coll-sci-fi-01&orientation=landscape",
    workIds: ["w-1001", "w-2005", "w-1002"],
  },
  {
    id: "c-02",
    title: "古装权谋大赏",
    subtitle: "一入深宫深似海",
    desc: "精致的年代质感与克制的表演，看尽深宫朝堂间的风云变幻与人心起落。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20ancient%20Chinese%20palace%20corridor%20with%20hanging%20lanterns%20and%20mist%2C%20warm%20crimson%20and%20gold%20tones%2C%20elegant%20editorial%20cover&width=800&height=600&seq=tc-coll-costume-02&orientation=landscape",
    workIds: ["w-2001", "w-2003"],
  },
  {
    id: "c-03",
    title: "治愈系生活剧单",
    subtitle: "慢下来，也很美好",
    desc: "当生活把人绊倒，这些作品会轻轻把你扶起来。适合在疲惫的夜晚慢慢观看。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cozy%20sunlit%20home%20with%20warm%20golden%20light%20and%20plants%2C%20soft%20rose%20and%20orange%20tones%2C%20heartwarming%20editorial%20cover&width=800&height=600&seq=tc-coll-healing-03&orientation=landscape",
    workIds: ["w-1004", "w-2006", "w-2004"],
  },
  {
    id: "c-04",
    title: "高分悬疑片单",
    subtitle: "真相往往藏在最后一秒",
    desc: "层层反转、伏笔密布，这组作品会挑战你的观察力与推理能力，看到最后才恍然大悟。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20moody%20night%20scene%20with%20a%20single%20street%20lamp%20in%20rain%20and%20deep%20shadows%2C%20warm%20amber%20highlight%2C%20editorial%20cover&width=800&height=600&seq=tc-coll-mystery-04&orientation=landscape",
    workIds: ["w-1003", "w-2002", "w-2005"],
  },
  {
    id: "c-05",
    title: "爆笑综艺合集",
    subtitle: "把快乐一次性拉满",
    desc: "从舞台到山野，从厨房到旅途，这一组综艺承包你一整季的笑点与放松时刻。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20bright%20stage%20with%20warm%20crimson%20and%20orange%20spotlights%20and%20confetti%2C%20joyful%20energetic%20editorial%20cover&width=800&height=600&seq=tc-coll-variety-05&orientation=landscape",
    workIds: ["w-3001", "w-3003", "w-3002", "w-3005"],
  },
  {
    id: "c-06",
    title: "华语爱情光影",
    subtitle: "关于相遇与告别的故事",
    desc: "有些遗憾本身就是答案。这组作品讲述了不同模样的爱情，总有一个瞬间会让你想起某个人。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20romantic%20sunset%20with%20two%20distant%20figures%20on%20a%20railway%20platform%2C%20soft%20rose%20and%20orange%20sky%2C%20tender%20editorial%20cover&width=800&height=600&seq=tc-coll-romance-06&orientation=landscape",
    workIds: ["w-1006", "w-2006"],
  },
];